import {auth} from '@/lib/firebaseAuth';

// Fetch the status of the user's job search
export const getStatus = async () => {
  const firebaseUser = auth.currentUser;

  if (!firebaseUser) {
    throw new Error('User not authenticated.');
  }

  const idToken = await firebaseUser.getIdToken();

  const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:8000/api'}/search/status`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    }
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to fetch search status.');
  }

  return response.json();
};

// Group all exports into a named object
export const SearchApi = {
  getStatus,
};